<style lang="less">
  :global(.suppress-scroll) {
    overflow: hidden;
  }
</style>

<script>
  import { afterUpdate, onMount, onDestroy } from 'svelte';

  export let scrollingElementAccessor = () => document.body;
  export let enable = false;

  let scrollingElement;

  onMount(() => (scrollingElement = scrollingElementAccessor()));

  afterUpdate(() => {
    if (!scrollingElement) {
      return;
    }

    scrollingElement.classList[enable ? 'add' : 'remove']('suppress-scroll');
  });

  onDestroy(() => {
    if (!scrollingElement) {
      return;
    }

    scrollingElement.classList.remove('suppress-scroll');
  });
</script>
